import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { generateUUID } from '../store/slices/deviceSlice';

/**
 * Hook to initialize device UUID on app startup
 * This should be called once at the app root level
 */
export const useDeviceInitialization = () => {
    const dispatch = useAppDispatch();
    const deviceUuid = useAppSelector((state) => state.device.uuid);

    useEffect(() => {
        // Only generate UUID if it doesn't exist
        if (!deviceUuid) {
            dispatch(generateUUID());
        }
    }, [dispatch, deviceUuid]);

    return {
        deviceUuid,
        isInitialized: !!deviceUuid,
    };
};
